/* Extracted from snippets/mobile-drawer.liquid on 2026-08-15.
   Was inline in every document that renders this file; now fetched once and
   cached. Deferred, so it runs after the DOM is parsed rather than at its old
   position — safer for the DOM queries inside, not riskier.
   No Liquid in here, which is why it could move at all. */

(function () {
    var dialog = document.getElementById('MobileMenu');
    if (!dialog) return;

    /* ── Lift the utility-bar links into the drawer ────────────────────────
       Three stacked rows made the mobile header too tall, and the last link
       was clipped at the right edge. The links belong to a different section,
       so rather than duplicating their URLs into header settings we clone the
       rendered list. The utility bar is only hidden AFTER a successful clone
       (via the --relocated class), so with JS off the links stay reachable
       where they are instead of disappearing. */
    (function relocateUtilityLinks() {
      var slot = dialog.querySelector('[data-md-quicklinks]');
      var bar = document.querySelector('.utility-bar');
      if (!slot || !bar) return;

      var list = bar.querySelector('.utility-bar__list');
      if (!list || !list.children.length) return;

      var copy = list.cloneNode(true);
      copy.classList.add('md__quicklinks-list');
      copy.removeAttribute('id');
      /* the clone is a second copy of the same links — keep it out of the
         accessibility tree twice over by giving it its own label */
      slot.appendChild(copy);
      slot.hidden = false;
      bar.classList.add('utility-bar--relocated');
    })();

    var tabs = dialog.querySelectorAll('.md__tab');
    var panels = dialog.querySelectorAll('.md__panel');

    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function () {
        var idx = this.getAttribute('data-tab-index');
        for (var j = 0; j < tabs.length; j++) {
          tabs[j].classList.remove('md__tab--active');
          tabs[j].setAttribute('aria-selected', 'false');
          tabs[j].setAttribute('tabindex', '-1');
          panels[j].classList.remove('md__panel--active');
          panels[j].hidden = true;
        }
        this.classList.add('md__tab--active');
        this.setAttribute('aria-selected', 'true');
        this.setAttribute('tabindex', '0');
        var target = dialog.querySelector('[data-panel-index="' + idx + '"]');
        if (target) {
          target.classList.add('md__panel--active');
          target.hidden = false;
        }
      });
    }
  })();
